import React, { useEffect, useState } from 'react'
import { useTheme } from "../../../Themecontext/Themecontext";
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Modal, Button } from "react-bootstrap";
import Input from '../../../components/FilterBox/Millstage/Input';
import { ProcessQualityShowAll, ProcessQualityShowOne, ProcessQualityInsert, ProcessQualityUpdate, ProcessQualityDelete } from '../../../Redux/Slice/MillstageEntry/MillstageEntrySlice';
import Millstagetablecruad from '../../../components/Tables/Millstagetablecruad';
import { toast } from "react-toastify";
import { Loader } from '../../../components/Loader/Loader';

const ProcessQuality = () => {
    const dispatch = useDispatch();

    const { Colourdata } = useSelector((state) => state.ClientLogin);
    const {
        ProcessQualityShowAlldata,
        ProcessQualityShowOnedata
    } = useSelector((state) => state.MillstageEntry || {});
    const iscolour = Colourdata?.data?.find(
        (el) => el.ExeName === "NEWMILLSTAGE",
    );
    const iscolourDark = Colourdata?.data?.find(
        (el) => el.ExeName === "NEWMILLSTAGEDARK",
    );

    const { theme } = useTheme();
    const isdark = theme;
    const [processQuality, setProcessQuality] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editMainId, setEditMainId] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const [rowToDelete, setRowToDelete] = useState(null);

    useEffect(() => {
        dispatch(ProcessQualityShowAll({}));
    }, [dispatch]);
    const TableColumns = [
        {
            label: "Sr. No.",
            key: "srNumber",
            align: "center",
        },
        {
            label: "Process Quality Name",
            key: "ProcessQualityName",
            align: "left",
        },
    ];
    const TableRows = (ProcessQualityShowAlldata?.Data || []).map((row) => ({
        ProcessQualityId: row?.ProcessQualityId,
        ProcessQualityName: row?.ProcessQualityName ?? "",
    }));
    const handleEdit = (row) => {
        const matchedRow = ProcessQualityShowAlldata?.Data?.find(
            item => item.ProcessQualityId === row.ProcessQualityId
        );
        if (!matchedRow) return;
        setEditMainId(matchedRow.ProcessQualityId);
        dispatch(
            ProcessQualityShowOne({
                MainID: matchedRow.ProcessQualityId
            })
        );
        setIsEditMode(true);
        setShowForm(true);
    };
    const handleDelete = (row) => {
        setRowToDelete(row);
        setConfirmAction("delete");
        setShowConfirmModal(true);
    };
    const executeDelete = async () => {
        const matchedRow = ProcessQualityShowAlldata?.Data?.find(
            item => item.ProcessQualityId === rowToDelete?.ProcessQualityId
        );
        if (!matchedRow) {
            setShowConfirmModal(false);
            return;
        }
        const result = await dispatch(
            ProcessQualityDelete({
                MainID: matchedRow.ProcessQualityId
            })
        );
        if (ProcessQualityDelete.fulfilled.match(result)) {
            if (result.payload?.status === "done") {
                toast.success(result.payload?.status);

                await dispatch(ProcessQualityShowAll({}));
            } else {
                toast.error(result.payload?.status || "Delete Failed");
            }
        } else {
            toast.error(result.payload?.status || "Delete Failed");
        }

        setShowConfirmModal(false);
        setRowToDelete(null);
    };
    useEffect(() => {
        if (
            ProcessQualityShowOnedata?.Data &&
            ProcessQualityShowOnedata.Data.length > 0
        ) {
            const data = ProcessQualityShowOnedata.Data[0];
            setProcessQuality(data.ProcessQualityName || "");
        }
    }, [ProcessQualityShowOnedata]);
    const handleSubmit = async () => {
        if (!processQuality || !processQuality.trim()) {
            toast.warning("Process Quality Name cannot be empty!");
            return;
        }
        if (isEditMode) {
            setConfirmAction("update");
            setShowConfirmModal(true);
        } else {
            const master = {
                ProcessQualityName: processQuality,
            };
            const detail = {
                ProcessQualityId: editMainId,
            };
            const result = await dispatch(
                ProcessQualityInsert({
                    master,
                    detail
                })
            );
            if (ProcessQualityInsert.fulfilled.match(result)) {
                if (result.payload?.status === "done") {
                    toast.success(result.payload?.status);
                    await dispatch(ProcessQualityShowAll({}));
                    setProcessQuality("");
                    setShowForm(false);
                } else {
                    toast.error(result.payload?.status);
                }
            } else {
                toast.error(result.payload?.status || "Insert Failed");
            }
        }
    };
    const executeUpdate = async () => {
        const master = {
            ProcessQualityName: processQuality
        };
        const detail = {
            ProcessQualityId: editMainId
        };
        const result = await dispatch(
            ProcessQualityUpdate({
                MainID: editMainId,
                master,
                detail
            })
        );
        if (ProcessQualityUpdate.fulfilled.match(result)) {
            if (result.payload?.status === "done") {
                toast.success(result.payload?.status);
            } else {
                toast.error(result.payload?.status);
            }
            await dispatch(ProcessQualityShowAll({}));
            setShowForm(false);
            setIsEditMode(false);
        } else {
            toast.error(result.payload?.status || "Update Failed");
        }
        setShowConfirmModal(false);
    };
    if (!ProcessQualityShowAlldata) {
        return (
            <div className="flex justify-center items-center h-screen">
                <Loader />
            </div>
        );
    }
    return (
        <div
            style={{
                background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
                minHeight: "100vh",
                padding: "16px",
            }}
        >
            <div className="d-flex justify-content-end  mb-3">
                <button
                    onClick={() => {
                        setShowForm(!showForm);
                        setIsEditMode(false);
                        setProcessQuality("");
                    }}
                    style={{
                        background:
                            isdark === "light"
                                ? iscolour?.Colour8
                                : iscolourDark?.Colour4,
                        color:
                            isdark === "light"
                                ? iscolour?.Colour1
                                : iscolourDark?.Colour1,
                        border: "none",
                        borderRadius: "10px",
                        padding: "10px 22px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        boxShadow: "0 3px 8px rgba(0,0,0,.15)",
                    }}
                >
                    + New Master
                </button>
            </div>
            {showForm && (
                <div
                    style={{
                        backgroundColor:
                            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour10,
                        padding: "15px",
                        borderRadius: "12px",
                        border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7
                            }`,
                    }}
                >
                    {/* Header */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "20px",
                            paddingBottom: "12px",
                            borderBottom: "1px solid #E5E7EB",
                        }}
                    >
                        <div
                            style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                background: isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour7,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: isdark === "light" ? iscolour?.Colour9 : "#fff",
                                fontSize: "18px",
                                fontWeight: "600",
                            }}
                        >
                            ✦
                        </div>
                        <div>
                            <h6
                                style={{
                                    margin: 0,
                                    fontWeight: "700",
                                    color: isdark === "light" ? iscolour?.Colour9 : "#fff",
                                }}
                            >
                                New Process Quality
                            </h6>
                            <small
                                style={{
                                    color: "#8B95A7",
                                    fontSize: "13px",
                                }}
                            >
                                Enter the sub process name
                            </small>
                        </div>
                    </div>
                    <Row className="g-2 align-items-end ">
                        <Col xs={12} sm={12} md={6} lg={6} xl={3} className="pb-2 pb-md-0">
                            <Input
                                label="Process Quality"
                                placeholder="Enter Process Quality"
                                value={processQuality}
                                onChange={(e) => setProcessQuality(e.target.value)}
                                required
                                isdark={isdark}
                                iscolour={iscolour}
                                iscolourDark={iscolourDark}
                            />
                        </Col>
                        {/* BUTTON */}
                        <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                            <button
                                onClick={handleSubmit}
                                style={{
                                    padding: "12px",
                                    backgroundColor:
                                        isdark === "light"
                                            ? iscolour?.Colour8
                                            : iscolourDark?.Colour4,
                                    color:
                                        isdark === "light"
                                            ? iscolour?.Colour1
                                            : iscolourDark?.Colour1,
                                    width: "100%",
                                    borderRadius: "12px",
                                    fontWeight: "700",
                                    border: "none",
                                }}
                            >
                                {isEditMode ? "Update" : "Submit"}
                            </button>
                        </Col>
                    </Row>
                </div>
            )}
            <div>
                <Row className="mt-3">
                    <Col xs={12}>
                        <div
                            style={{
                                borderRadius: "12px",
                                overflowX: "auto",
                                width: "100%",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                            }}
                        >
                            {/* Header */}
                            <div
                                style={{
                                    padding: "14px",
                                    background:
                                        isdark === "light"
                                            ? iscolour?.Colour6
                                            : iscolourDark?.Colour4,
                                    color: "#fff",
                                    fontWeight: "600",
                                    letterSpacing: "1px"
                                }}
                            >
                                Process Quality Records
                            </div>
                            {/* Table */}
                            <Millstagetablecruad
                                columns={TableColumns}
                                data={TableRows}
                                showActions={true}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                            />
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Confirmation Modal */}
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                <Modal.Header closeButton style={{ background: isdark === "light" ? "#f8f9fa" : "#1e293b", color: isdark === "light" ? "#000" : "#fff", borderBottom: `1px solid ${isdark === "light" ? "#e5e7eb" : "#334155"}` }}>
                    <Modal.Title style={{ fontSize: "18px", fontWeight: "600" }}>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: isdark === "light" ? "#fff" : "#0f172a", color: isdark === "light" ? "#333" : "#cbd5e1" }}>
                    Are you sure you want to {confirmAction} this sub process?
                </Modal.Body>
                <Modal.Footer style={{ background: isdark === "light" ? "#f8f9fa" : "#1e293b", borderTop: `1px solid ${isdark === "light" ? "#e5e7eb" : "#334155"}` }}>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant={confirmAction === "delete" ? "danger" : "primary"}
                        onClick={confirmAction === "delete" ? executeDelete : executeUpdate}
                    >
                        Yes, {confirmAction === "delete" ? "Delete" : "Update"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default ProcessQuality